import { Component, OnInit } from '@angular/core';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { AmChartsDirective } from '@amcharts/amcharts3-angular';

@Component({
  selector: 'app-payment-dashboard',
  templateUrl: './payment-dashboard.component.html',
  styleUrls: ['./payment-dashboard.component.css']
})
export class PaymentDashboardComponent implements OnInit {

  months:any=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  years:any=[];
  yearRange:any=[-5,-4,-3,-2,-1,0,1,2,3,4,5];
  chartDataRecieved=false;
  
  paymentDashboardDataForPitChart: any = [
    {
      "status": "Referral",
      "count": 10
    },
    {
      "status": "Fundus Examination",
      "count": 4
    },
    {
      "status": "Fundus Examination (Autonomous)",
      "count": 14
    },
    {
      "status": "Referaction",
      "count": 20
    },
    {
      "status": "Tele Refraction",
      "count": 20
    },
    {
      "status": "Spectacle (Basic)",
      "count": 20
    },
    {
      "status": "Spectacle (Advanced)",
      "count": 20
    }
  ];

  paymentDashboardDataForStackChart: any = [{
    "country": "Jan",
    "visits": 2025
  }, {
    "country": "Feb",
    "visits": 1882
  }, {
    "country": "Mar",
    "visits": 1809
  }, {
    "country": "Apr",
    "visits": 1322
  }, {
    "country": "May",
    "visits": 1122
  }, {
    "country": "Jun",
    "visits": 1114
  }];


  paymentDashboardMonthlyDataForStackChart:any=[{
    "date": "2019-01-01",
    "refractionValue": 2025,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-02",
    "refractionValue": 1882,
	"teleRefractionValue" : 50
  }, {
    "date": "2019-01-03",
    "refractionValue": 1809,
	"teleRefractionValue" : 80
  }, {
    "date": "2019-01-04",
    "refractionValue": 1322,
	"teleRefractionValue" : 90
  }, {
    "date": "2019-01-05",
    "refractionValue": 1122,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-06",
    "refractionValue": 1114,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-07",
    "refractionValue": 1882,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-08",
    "refractionValue": 1809,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-09",
    "refractionValue": 1322,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-10",
    "refractionValue": 1122,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-12",
    "refractionValue": 1114,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-13",
    "refractionValue": 1882,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-14",
    "refractionValue": 1809,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-15",
    "refractionValue": 1322,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-16",
    "refractionValue": 1122,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-17",
    "refractionValue": 1114,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-18",
    "refractionValue": 1882,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-19",
    "refractionValue": 1809,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-20",
    "refractionValue": 1322,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-21",
    "refractionValue": 1122,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-22",
    "refractionValue": 1114,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-23",
    "refractionValue": 1882,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-24",
    "refractionValue": 1809,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-25",
    "refractionValue": 1322,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-26",
    "refractionValue": 1122,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-27",
    "refractionValue": 1114,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-28",
    "refractionValue": 1882,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-29",
    "refractionValue": 1809,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-30",
    "refractionValue": 1322,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-01-31",
    "refractionValue": 1122,
	"teleRefractionValue" : 10
  }];

  paymentDashboardDataForStackChart2:any=[ {
    "date": "2019-01-01",
    "refractionValue": 2025,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-02-01",
    "refractionValue": 1882,
	"teleRefractionValue" : 50
  }, {
    "date": "2019-03-01",
    "refractionValue": 1809,
	"teleRefractionValue" : 80
  }, {
    "date": "2019-04-01",
    "refractionValue": 1322,
	"teleRefractionValue" : 90
  }, {
    "date": "2019-05-01",
    "refractionValue": 1122,
	"teleRefractionValue" : 10
  }, {
    "date": "2019-06-01",
    "refractionValue": 1114,
	"teleRefractionValue" : 10
  }];
  constructor() { }

  generateYears(){
    for(var i=0;i<this.yearRange.length;i++){
      this.years.push(this.yearRange[i]+new Date().getFullYear());
    }
  }

  getStatistics(){
    this.chartDataRecieved=true;
  }


  ngOnInit() {
    this.generateYears();

  }

}
